// Google AdSense configuration.
//
// Until you have an approved AdSense account, leave ADSENSE_CLIENT empty — the
// AdSlot component falls back to the placeholder box, so nothing breaks.
//
// Once approved:
//   1. Set ADSENSE_CLIENT to your publisher ID, e.g. "ca-pub-1234567890123456".
//   2. Create two display ad units in the AdSense dashboard (one per sidebar)
//      and paste their slot IDs into AD_SLOTS below.
//   3. Add an ads.txt at the site root — the server already serves one when the
//      ADSENSE_PUB env var is set (the "pub-…" part of your client ID).
//
// A global injected by the server (window.ADSENSE_CLIENT) takes precedence, so
// you can also configure it via the ADSENSE_CLIENT env var at deploy time
// instead of editing this file.

export const ADSENSE_CLIENT =
  (typeof window !== "undefined" && window.ADSENSE_CLIENT) || "";

export const AD_SLOTS = {
  left: "", // sidebar (options panel) display unit slot id
  right: "", // sidebar (struct view) display unit slot id
};

export const adsEnabled = () => Boolean(ADSENSE_CLIENT);
